export default {
  // 頁面標題
  title: '活動詳情',
  // KPI 卡片
  participantCount: '活動參與人數',
  winnerCount: '中獎人數',
  loserCount: '未中獎人數',
  yesterday: '昨日:',
  // Tab 標籤
  tabBasic: '基本信息',
  tabScope: '活動範圍',
  tabPrize: '活動獎項',
  tabStrategy: '活動策略',
  // 基本信息
  activityStatus: '活動狀態',
  activityName: '活動名稱',
  activityId: '活動ID',
  activityTemplate: '活動模板',
  activityTime: '活動時間期間',
  activityRemark: '活動備註',
  activityRule: '活動規則',
  createTime: '創建時間',
  // 活動範圍
  colRangeType: '範圍類型',
  colCodeRange: '碼段範圍',
  colCodeCount: '碼數量',
  emptyScope: '暫無活動範圍數據',
  // 活動獎項
  colPrizeName: '獎項名稱',
  colPrizePercent: '中獎概率',
  colPrizeContent: '獎項內容',
  colPrizePloy: '關聯策略',
  emptyPrize: '暫無活動獎項數據',
  // 活動策略
  colStrategyName: '策略名稱',
  colStrategyRules: '策略規則',
  colStrategyStatus: '策略狀態',
  emptyStrategy: '暫無活動策略數據',
};
